export default __webpack_public_path__ + "static/media/minion2.a34d4740.jpg";